import { AuthService } from './../../../../services/user/auth.service';
import { Router } from '@angular/router';
import { LoyaltyReasonService } from './../../../../services/loyalty/reason.service';
import { Reason } from './../../../../models/loyalty-reason.model';
import { Observable } from 'rxjs';
import { LoyaltyParamsService } from './../../../../services/loyalty/params.service';
import { LoyaltyPointTransferAdd } from './../../../../models/loyalty-point-transfer.model';
import { LoyaltyPointTransferService } from './../../../../services/loyalty/loyalty-point-transfers.service';
import { Acm } from './../../../../models/loyalty-acm.model';
import { LoyaltyAcmService } from './../../../../services/loyalty/loyalty-acm.service';
import { MessageService, SelectItem } from 'primeng/primeng';
import { Card } from './../../../../models/loyalty-card.model';
import { TranslateService } from '@ngx-translate/core';
import { Validators, AbstractControl } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-point-transfer-loyalty',
  templateUrl: './form-point-transfer-loyalty.component.html',
  styleUrls: ['./form-point-transfer-loyalty.component.css']
})
export class FormPointTransferLoyaltyComponent implements OnInit {

  sourceCard: Card;
  private destinationCard: Card;
  private selectedAcm: Acm;
  private acmDestination: Acm;
  private reasonSource: Reason;
  private reasonDestination: Reason;
  // private pointTransferToAdd: LoyaltyPointTransferAdd;

  accumulators = [];

  inputValue = {
    reasonSource: "",
    reasonDestination: ""
  }

  currentChannelId = "";

  maxPoints: number = 0;

  show = {
    form: false,
    selectCardSource: false,
    selectCardDestination: false
  }
  translations = {};
  title = "";
  form: FormGroup

  isCardSourcePresent = false;
  isCardDestinationPresent = false;

  constructor(
    private fb: FormBuilder,
    private srvTranslate: TranslateService,
    private srvMessage: MessageService,
    private srvAccumulator: LoyaltyAcmService,
    private srvParam: LoyaltyParamsService,
    private srvReason: LoyaltyReasonService,
    private srvPointTransfer: LoyaltyPointTransferService,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.initForm();

    let ParamReasonSource = this.srvParam.getParamByKey('POINTTRANSFER.REASON.SRC');
    let ParamReasonDestination = this.srvParam.getParamByKey('POINTTRANSFER.REASON.DEST')
    let Translate = this.srvTranslate.get([
      'customers.accumulator',
      'loyalty.point_transfer',
      'pointTransfer.cardDestination',
      'loyalty.points',
      'pointTransfer.add_title',
      'pointTransfer.cardSource',
      'pointTransfer.source',
      'pointTransfer.destination',
      'pointTransfer.selectCardPlaceholder',
      'pointTransfer.selectAccumulatorPlaceholder',
      'pointTransfer.pointsPlaceholder',
      'pointTransfer.message_selectCardFirst',
      'pointTransfer.message_noCustomer',
      'pointTransfer.message_noAccumulator',
      'pointTransfer.message_noSameCard',
      'pointTransfer.message_noSameChannel',
      'pointTransfer.message_noSameAccumulator',
      'common.save_ok'
    ]);

    Observable.zip(
      Translate,
      ParamReasonSource,
      ParamReasonDestination,
    ).subscribe(([translations,
      reasonSourceParam,
      reasonDestinationParam
    ]) => {

      this.translations = {
        accumulator: translations['customers.accumulator'],
        add_title: translations['pointTransfer.add_title'],
        point_transfer: translations['loyalty.point_transfer'],
        cardSource: translations['pointTransfer.cardSource'],
        cardDestination: translations['pointTransfer.cardDestination'],
        points: translations['loyalty.points'],
        source: translations['pointTransfer.source'],
        destination: translations['pointTransfer.destination'],
        selectCardPlaceholder: translations['pointTransfer.selectCardPlaceholder'],
        selectAccumulatorPlaceholder: translations['pointTransfer.selectAccumulatorPlaceholder'],
        pointsPlaceholder: translations['pointTransfer.pointsPlaceholder'],
        message_selectCardFirst: translations['pointTransfer.message_selectCardFirst'],
        message_noCustomer: translations['pointTransfer.message_noCustomer'],
        message_noAccumulator: translations['pointTransfer.message_noAccumulator'],
        message_noSameCard: translations['pointTransfer.message_noSameCard'],
        message_noSameChannel: translations['pointTransfer.message_noSameChannel'],
        message_noSameAccumulator: translations['pointTransfer.message_noSameAccumulator'],
        message_selectAccumulatorFirst: translations['pointTransfer.message_selectAccumulatorFirst'],
        save_ok: translations['common.save_ok']
      };

      let idReasonSource = 0;
      let idReasonDestination = 0;

      if(reasonSourceParam){
        idReasonSource = +reasonSourceParam.param_code;
      }
      if(reasonDestinationParam){
        idReasonDestination = +reasonDestinationParam.param_code;
      }

      this.title = this.translations["add_title"];

      let ReasonSource = this.srvReason.get(idReasonSource);
      let ReasonDestination = this.srvReason.get(idReasonDestination);


      Observable.zip(
        ReasonSource,
        ReasonDestination,
      ).subscribe(([
        reasonSource,
        reasonDestination
      ]) => {
        this.reasonSource = reasonSource;
        this.reasonDestination = reasonDestination;
        this.inputValue.reasonSource = this.reasonSource.reason_code + " - "+ this.reasonSource.description;
        this.inputValue.reasonDestination = this.reasonDestination.reason_code + " - "+ this.reasonDestination.description;
        this.show.form = true;
      });


    });
  }

  initForm(){
    this.form = this.fb.group( {
      'card_source': new FormControl(null,  Validators.required),
      'accumulator': new FormControl( null , Validators.required),
      'points': new FormControl(null,   Validators.compose([ Validators.required, Validators.min(1), (control: AbstractControl) => Validators.max(this.maxPoints)(control)])),
      'card_destination': new FormControl(null,  Validators.required)
    });

    //osservazione: in points c'è un validatore max dinamico perchè il valore del massimo può cambiare a seconda dell'accumulatore scelto
  }

  onOpenSelectCardSource(){
    this.clearStoredFilters();
    this.show.selectCardSource = true;
  }

  loadAccumulatorsSource(card: Card) {
    // recupero gli accumulatori del customerID, validi con saldo positivo
    let searchParams = [
      {key: "cardNo", value: card.card_no},
      {key: "customerId", value: card.vCustomerId.toString()},
      {key: "status", value: "valid"},
      {key: "balanceMin", value: "1"},
      {key: "companyCode", value: this.authService.user.selectedCompany.toString()}
    ];
    this.srvAccumulator.getKloyAccumulators(searchParams).subscribe(res => {
      if(res && res.data && res.data.length > 0){
        const sourceAcm = [];
        res.data.forEach(acm => {
          acm['accumulatorCustomDescription'] = acm.acm_code + " - " + acm.acmDescription;
          if (acm.flg_visible === "0") {
            sourceAcm.push(acm);
          }
        });
        this.accumulators = sourceAcm;
      }
      else{
        this.srvMessage.add({severity: 'error', summary: 'Error', detail: this.translations['message_noAccumulator']});
      }
    });
  }

  loadAccumulatorsDestination(card: Card){

    //carico gli accumulatori validi dello stesso canale. Mi serve per recuperare il saldo della destinazione. Se non trovo accumulatori vuol dire che il saldo è uguale a zero.
    let searchParams = [
      {key: "cardNo", value: card.card_no},
      {key: "customerId", value: card.vCustomerId.toString()},
      {key: "status", value: "valid"},
      {key: "balanceMin", value: "1"},
      {key: "companyCode", value: this.authService.user.selectedCompany.toString()}
    ];
    this.srvAccumulator.getKloyAccumulators(searchParams).subscribe(res=>{
      // passandogli anche l'id del canale, l'accumulatore sarà univoco
      if(res && res.data && res.data.length > 0 ){
        res.data.forEach(acm => {
          if(acm.acm_code ===  this.selectedAcm.acm_code){
            this.acmDestination = acm;
            this.destinationCard = card;
            this.show.selectCardDestination = false;
            this.form.get('card_destination').setValue(card.card_no);
          }
        });
      }
      else{
        this.acmDestination = null;
      }
    });
  }

  onOpenSelectCardDestination(){
    this.clearStoredFilters();
    //quando apro la selezione della carta di destinazione, controllo prima se è stato selezionata prima la carta sorgente
    if(this.sourceCard){
      this.show.selectCardDestination = true;
    }
    else{
      this.srvMessage.add({severity: 'error', summary: 'Error', detail: this.translations['message_selectCardFirst']});
    }
  }

  onSourceCardSelected(card: Card){
    //controllo se ha il customerId altrimenti non posso andare avanti
    if(card.vCustomerId){
      this.form.get('card_source').setValue(card.card_no + " - " + card.customerDescription);
      this.sourceCard = card;
      this.selectedAcm = null;
      this.maxPoints = 0;
      this.destinationCard = null;
      this.show.selectCardSource = false;
      this.currentChannelId = card.channel_id;
      this.isCardSourcePresent = true;
      this.loadAccumulatorsSource(card);
    }
    else{
      this.srvMessage.add({severity: 'error', summary: 'Error', detail: this.translations['message_noCustomer']});
    }
  }

  onDestinationCardSelected(card: Card){
    //controllo se ha il customerId altrimenti non posso andare avanti
    if(card.vCustomerId){
      this.isCardDestinationPresent = true;
      //controllo che la carta sia diversa
      if(this.sourceCard.id == card.id){
        this.srvMessage.add({severity: 'error', summary: 'Error', detail: this.translations['message_noSameCard']});
      }
      //controllo che il canale sia lo stesso
      else if(this.sourceCard.channel_id != card.channel_id){
        this.srvMessage.add({severity: 'error', summary: 'Error', detail: this.translations['message_noSameChannel']});
      }
      else{
        this.destinationCard = card;
        this.show.selectCardDestination = false;
        //per controllo che destinazione ha lo stesso accumulatore scelto
        this.form.get('card_destination').setValue(card.card_no + " - " + card.customerDescription);
        this.loadAccumulatorsDestination(card);
      }

    }
    else{
      this.srvMessage.add({severity: 'error', summary: 'Error', detail: this.translations['message_noCustomer']});
    }
  }

  onChangeAccumulator(){
    // quando cambia l'accumulatore scelto cambio il massimo dei punti trasferibili
    this.maxPoints = this.selectedAcm.value;
  }

  onClickSave(){
    const pointTransferToAdd = {
      cardSrc: this.sourceCard.card_no,
      cardDest: this.destinationCard.card_no,
      cardSrcId: +this.sourceCard.id,
      cardDestId: +this.destinationCard.id,
      customerSrcId: this.sourceCard.vCustomerId,
      customerDestId: this.destinationCard.vCustomerId,
      amount: this.form.get('points').value,
      acmCode: this.selectedAcm.acm_code,
      acmId: +this.selectedAcm.id,
      reasonSrcId: +this.reasonSource.id,
      reasonDestId: +this.reasonDestination.id,
      balanceBeforeSrc: this.maxPoints,
      balanceAfterSrc: this.maxPoints - this.form.get('points').value,
      balanceBeforeDest: this.acmDestination ? this.acmDestination.value : 0,
      balanceAfterDest: this.acmDestination ? (this.acmDestination.value + this.form.get('points').value) : this.form.get('points').value
    };
    this.srvPointTransfer.create(pointTransferToAdd, this.authService.user.selectedCompany).subscribe(res=>{
      if(res){
        this.srvMessage.add({severity: 'success', summary: 'Success', detail: this.translations["saved_ok"]});
        this.router.navigate(['/loyalty/point_transfer']);
      }
      else{
        this.srvMessage.add({severity: 'error', summary: 'Error', detail: this.translations['message_noSameChannel']});
      }
    });
  }

  clearCardSource() {
    this.form.get('card_source').setValue('');
    this.sourceCard = null;
    this.isCardSourcePresent = false;
  }

  clearCardDestination() {
    this.form.get('card_destination').setValue('');
    this.destinationCard = null;
    this.isCardDestinationPresent = false;
  }

  clearStoredFilters() {
    Object.keys(sessionStorage).forEach(key => {
      if (key.includes('Service') || key.includes('SourceFilters')) {
        sessionStorage.removeItem(key);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-point-transfer/form-point-transfer-loyalty/form-point-transfer.component.ts